<div class="casino-image-loader">
    <img
        id="image"
        alt="no-fallback"
        loading="eager"
        [style]="computedStyle()"
        [src]="optimizedUrl()"
        [ngClass]="{
            'game-image-block-version': isBlockModuleVersion(),
            'game-image-default-version': !isBlockModuleVersion(),
            'image-loading': !isImageLoaded(),
        }"
        (load)="onImageLoaded()" />
    <img
        id="placeholder"
        alt="placeholder"
        [style]="computedStyle()"
        [src]="defaultSrc"
        [ngClass]="{
            'game-image-block-version': isBlockModuleVersion(),
            'game-image-default-version': !isBlockModuleVersion(),
            'image-loading': isImageLoaded(),
        }" />
</div>
